var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _path8, _path9, _path0, _circle3, _path1, _path10, _path11, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 40,
    fill: "#4bc0ff",
    r: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m279.802 110h-47.604c-18.364 0-34.369 12.504-38.812 30.323l-9.29 37.258c-1.573 6.31 3.2 12.419 9.703 12.419h124.401c6.503 0 11.276-6.109 9.703-12.419l-9.29-37.258c-4.442-17.819-20.447-30.323-38.811-30.323z",
    fill: "#4bc0ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m296 40c0-22.091-17.909-40-40-40v80c22.091 0 40-17.909 40-40z",
    fill: "#0592fd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m327.903 177.581-9.29-37.258c-4.442-17.819-20.447-30.323-38.811-30.323h-23.802v80h62.201c6.503 0 11.276-6.109 9.702-12.419z",
    fill: "#0592fd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m56 301c-.011 0-.021 0-.033 0-8.284-.018-14.985-6.748-14.968-15.032.123-57.246 22.488-111.068 62.974-151.554 5.857-5.858 15.355-5.858 21.213 0s5.858 15.355 0 21.213c-34.836 34.836-54.08 81.149-54.186 130.405-.018 8.274-6.73 14.968-15 14.968z",
    fill: "#466288"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m455.999 301c-8.27 0-14.981-6.694-14.999-14.968-.106-49.257-19.351-95.569-54.187-130.406-5.858-5.858-5.858-15.355 0-21.213 5.857-5.858 15.355-5.858 21.213 0 40.485 40.485 62.85 94.308 62.974 151.554.018 8.284-6.684 15.015-14.968 15.032-.011.001-.022.001-.033.001z",
    fill: "#354a67"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m256 501.467c-14.362 0-28.725-1.449-42.987-4.348-8.119-1.649-13.362-9.567-11.713-17.687 1.649-8.118 9.563-13.366 17.687-11.712 24.561 4.991 49.467 4.991 74.026 0 8.126-1.653 16.038 3.595 17.687 11.712 1.65 8.119-3.594 16.037-11.712 17.687-14.263 2.899-28.626 4.348-42.988 4.348z",
    fill: "#466288"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m232.846 356.577c-3.839 0-7.678-1.465-10.606-4.394l-26.846-26.846c-5.858-5.857-5.858-15.355 0-21.213 5.857-5.857 15.355-5.857 21.213 0l16.239 16.239 62.548-62.548c5.857-5.858 15.355-5.858 21.213 0 5.858 5.857 5.858 15.355 0 21.213l-73.154 73.154c-2.93 2.93-6.768 4.395-10.607 4.395z",
    fill: "#466288"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.205,
    cy: 362,
    fill: "#e25a6e",
    r: 40
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m96.007 432h-47.604c-18.364 0-34.369 12.504-38.812 30.323l-9.29 37.258c-1.573 6.31 3.2 12.419 9.703 12.419h124.401c6.503 0 11.276-6.109 9.703-12.419l-9.29-37.258c-4.442-17.819-20.447-30.323-38.811-30.323z",
    fill: "#e25a6e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m112.205 362c0-22.091-17.909-40-40-40v80c22.092 0 40-17.909 40-40z",
    fill: "#d62f44"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m144.109 499.581-9.29-37.258c-4.443-17.819-20.448-30.323-38.812-30.323h-23.802v80h62.201c6.503 0 11.276-6.109 9.703-12.419z",
    fill: "#d62f44"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 439.795,
    cy: 362,
    fill: "#a3ce29",
    r: 40
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m463.597 432h-47.604c-18.364 0-34.369 12.504-38.812 30.323l-9.29 37.258c-1.573 6.31 3.2 12.419 9.703 12.419h124.401c6.503 0 11.276-6.109 9.703-12.419l-9.29-37.258c-4.442-17.819-20.447-30.323-38.811-30.323z",
    fill: "#a3ce29"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m479.795 362c0-22.091-17.909-40-40-40v80c22.091 0 40-17.909 40-40z",
    fill: "#8eba05"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m511.698 499.581-9.29-37.258c-4.443-17.819-20.447-30.323-38.811-30.323h-23.802v80h62.201c6.502 0 11.275-6.109 9.702-12.419z",
    fill: "#8eba05"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#354a67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m316.606 257.816c-5.857-5.858-15.355-5.858-21.213 0l-39.393 39.394v42.426l60.606-60.606c5.859-5.858 5.859-15.356 0-21.214z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.699 479.433c-1.648-8.117-9.561-13.365-17.687-11.712-12.279 2.496-24.646 3.743-37.013 3.743v30.003c14.362 0 28.725-1.449 42.987-4.348 8.119-1.649 13.364-9.567 11.713-17.686z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageUser);
export default __webpack_public_path__ + "static/media/manageUser.325614a3087ab037c03b7cb038980b07.svg";
export { ForwardRef as ReactComponent };